/**
 * 生成数量选择器（1 ~ maxJobsPerSubmit）
 *
 * compact：画布节点参数弹层等窄容器里使用（小字号 + 按钮可换行）
 */

interface VideoCountSelectorProps {
  value: number;
  onChange: (value: number) => void;
  max: number;
  compact?: boolean;
}

export function VideoCountSelector({ value, onChange, max, compact = false }: VideoCountSelectorProps) {
  const options = Array.from({ length: Math.max(1, max) }, (_, i) => i + 1);

  return (
    <div>
      <div className={`flex items-center justify-between ${compact ? 'mb-1' : 'mb-2'}`}>
        <span
          className={compact ? 'text-[10px] text-slate-400' : 'text-sm font-medium text-light-text'}
        >
          生成数量
        </span>
        {compact ? (
          <span className="text-[10px] text-slate-400">最多 {max}</span>
        ) : (
          <span className="text-xs text-light-muted">单次最多 {max} 个</span>
        )}
      </div>
      <div className={compact ? 'flex flex-wrap gap-1' : 'flex gap-2'}>
        {options.map((n) => {
          const isActive = n === value;
          return (
            <button
              key={n}
              type="button"
              onClick={() => onChange(n)}
              className={
                compact
                  ? `min-w-[2rem] flex-1 rounded-md border py-1 text-[11px] font-medium transition ${
                      isActive
                        ? 'border-purple-300 bg-purple-50 text-purple-700'
                        : 'border-light-border bg-white text-slate-500 hover:bg-slate-50'
                    }`
                  : `flex-1 py-2 rounded-lg border text-sm font-medium transition-all ${
                      isActive
                        ? 'border-accent-blue bg-accent-blue text-white shadow-md'
                        : 'border-light-border bg-white text-light-secondary hover:border-accent-blue hover:text-accent-blue'
                    }`
              }
            >
              {n}
            </button>
          );
        })}
      </div>
    </div>
  );
}
